import React, { useEffect, useState, useRef } from 'react'
import { Link } from "gatsby"
import * as styles from './mobilemenu.module.scss'
import settings from '../../helpers/settings'

export const MobileMenu = ({ menuItems, mobileMenu }) => {

    const subitemsRef = useRef([])

    const logo = settings[ process.env.GATSBY_SITE_LANG ].logo

    const [ start, setStart ] = useState( false )

    const menuParent = useRef([])

    useEffect(() => {
        
        let timer 
        mobileMenu ? 
        timer = setTimeout(() => {
            setStart(true)
        }, 200)
        :
        timer = setTimeout(() => {
            setStart(false)
        }, 200)

        mobileMenu ? document.getElementsByTagName('html')[0].style.overflow = 'hidden' : document.getElementsByTagName('html')[0].style.overflow = ''

        return () => clearTimeout( timer )

    }, [ mobileMenu ])

    const handleMenuAction = ( e, id, childrenCount ) => {

        if(childrenCount > 0){
            e.preventDefault()
        } 
        if(menuParent.current[id].classList.contains( styles.show__sub )){
            menuParent.current[id].classList.remove( styles.show__sub )
            menuParent.current[id].style.backgroundColor = ''
        } else {
            menuParent.current[id].classList.add( styles.show__sub )
        }
       
    }

    return(
        <div className={`${styles.mobileMenu} ${start ? styles.activeMobileMenu : ''}`}>
            <div className={styles.mobileMenu__wrapper}>
                {/* <div className={styles.mobileMenu__logo}>
                    <img src={logo} alt={'Bedbible logo'}/>
                </div> */}
                <div className={styles.mobileMenu__nav}>
                    <ul className={styles.mobileMenu__list}>
                    {menuItems.map((item, id) => 
                        <li 
                            ref={el => menuParent.current[id] = el}
                            className={styles.mobileMenu__item}                  
                            key={`mm-${id}`}
                            >
                            {item.url !== null ?
                            <Link 
                                className={styles.menu__link}
                                onClick={( e ) => handleMenuAction( e, id, item.childrenItems.length, item.url )}
                                to={item.url?.replace('https://wp.bedbible.com', '')}
                                >
                                {item.label}
                                {item.childrenItems.length > 0 &&
                                <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.42503 5.49388L10.668 1.25088C11.0585 0.86042 11.6916 0.860419 12.082 1.25088C12.4725 1.64135 12.4725 2.27442 12.082 2.66488L6.42503 8.32188L0.768035 2.66488C0.37757 2.27442 0.37757 1.64135 0.768035 1.25088C1.1585 0.860419 1.79157 0.860419 2.18204 1.25088L6.42503 5.49388Z" fill="white"/>
                                </svg>
                               }
                            </Link>
                            :
                            <span className={`${styles.emptyItem} ${styles.menu__link}`} onClick={( e ) => handleMenuAction( e, id, item.childrenItems.length, item.url )}>
                                {item.label}
                                {item.childrenItems.length > 0 &&
                                <svg className={styles.chevrone} width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.42503 5.49388L10.668 1.25088C11.0585 0.86042 11.6916 0.860419 12.082 1.25088C12.4725 1.64135 12.4725 2.27442 12.082 2.66488L6.42503 8.32188L0.768035 2.66488C0.37757 2.27442 0.37757 1.64135 0.768035 1.25088C1.1585 0.860419 1.79157 0.860419 2.18204 1.25088L6.42503 5.49388Z" fill="#1D1D1F"/>
                                </svg>}
                            </span>
                            }
                            {item.childrenItems.length > 0 &&
                                <ul className={`${styles.mobileSubmenu__list}`}>
                                    {item.childrenItems.map((itm, i) => 
                                    <li 
                                        className={`${styles.mobileSubmenu__item} ${styles.mobileSubmenu__item__subitem}`} 
                                        key={`ms-${i}`} 
                                        ref={ el => itm?.childrenItems?.length > 0 && ( subitemsRef.current[i] = el )}>
                                        <Link className={styles.subitem__menu__link} to={itm.url?.replace('https://wp.bedbible.com', '')}>
                                            <span>{itm.label}</span>
                                            <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.3153 16.6681C15.9247 17.0587 15.9247 17.6918 16.3153 18.0824C16.7058 18.4729 17.339 18.4729 17.7295 18.0824L22.3951 13.4168C23.1761 12.6357 23.1761 11.3694 22.3951 10.5883L17.7266 5.9199C17.3361 5.52938 16.703 5.52938 16.3124 5.91991C15.9219 6.31043 15.9219 6.9436 16.3124 7.33412L19.9785 11.0002L2 11.0002C1.44772 11.0002 1 11.4479 1 12.0002C1 12.5524 1.44772 13.0002 2 13.0002L19.9832 13.0002L16.3153 16.6681Z" fill="#0F0F0F"/>
                                            </svg>
                                        </Link>
                                        {itm?.childrenItems?.length > 0 &&
                                        <ul className={styles.subitem__menu}>
                                            {itm.childrenItems.map((it, i) =>
                                            <li className={`${styles.subitem__menu__item} ${styles.mobileSubmenu__item__subitem}`} key={`ms-${i}`}>
                                                <Link className={styles.subitem__menu__item__link} to={it.url?.replace('https://wp.bedbible.com', '')}>
                                                    <span>{it.label}</span>
                                                </Link>
                                            </li>
                                            )}
                                        </ul>}
                                    </li>
                                    )}
                                </ul>}
                        </li>)}
                    </ul>
                </div>
            </div>
        </div>
    )
}